import React from "react";
const SvgDsGarage = props => (
  <svg fill="none" viewBox="0 0 24 25" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M15.07 5.5H8.93c-.928 0-1.735.64-1.943 1.542l-.002.012L6.159 10h11.682l-.826-2.946-.002-.012A1.993 1.993 0 0015.07 5.5zm5.155 4.952c1.06.6 1.775 1.74 1.775 3.048v6.25a1.75 1.75 0 01-1.75 1.75H18c-1.106 0-2-.894-2-2V19H8v.5c0 1.106-.894 2-2 2H3.75A1.75 1.75 0 012 19.75V13.5c0-1.309.714-2.447 1.775-3.048l-1.433-.478a.5.5 0 11.316-.948l2.502.834.856-3.054A2.993 2.993 0 018.93 4.5h6.14c1.388 0 2.598.954 2.915 2.306l.855 3.054 2.502-.834a.5.5 0 01.316.948l-1.433.478zM18.5 11h-13A2.496 2.496 0 003 13.5v6.25c0 .414.336.75.75.75H6c.554 0 1-.446 1-1v-1a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v1c0 .554.446 1 1 1h2.25a.75.75 0 00.75-.75V13.5c0-1.384-1.116-2.5-2.5-2.5zm-3.25 3.5a.5.5 0 01.5-.5h2.5a.5.5 0 110 1h-2.5a.5.5 0 01-.5-.5zm-10 0a.5.5 0 01.5-.5h2.5a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDsGarage;
